import { render, staticRenderFns } from "./ProductSection.vue?vue&type=template&id=d29e093c&scoped=true&"
import script from "./ProductSection.vue?vue&type=script&lang=ts&"
export * from "./ProductSection.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSection.vue?vue&type=style&index=0&id=d29e093c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29e093c",
  null
  
)

export default component.exports